/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * document_storage_service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Which CRM entity a comment thread is attached to. Serializes to
`crm_company` / `crm_contact` — matching the `entityType` the frontend
uses elsewhere when building entity URLs — and is parsed from the
`{entity_type}` path segment on the comment routes.
 */
export type CrmCommentEntityType =
  (typeof CrmCommentEntityType)[keyof typeof CrmCommentEntityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CrmCommentEntityType = {
  crm_company: 'crm_company',
  crm_contact: 'crm_contact',
} as const;
